import { Tabs } from "antd";

import email from "../../assets/images/email-setup/email-5.svg";
import RemoveAccount from "./RemoveAccount";

const AccountManagement = ({ emailConfiguration, onRemove }) => {
  return (
    <div className="settings-card h-100">
      <h1 className="heading24px fw-bold" style={{ paddingBottom: 5 }}>
        Account Management
      </h1>
      <Tabs
        defaultActiveKey="1"
        items={[
          {
            key: "1",
            label: "Account Detail",
            children: (
              <div className="d-flex align-items-center flex-column mt60">
                <img src={email} alt="" />
                <p className="heading18px fw-bold mt30">
                  Your Email is Connected!
                </p>
                <p className="heading13px mt10">
                  <b>Email:</b> {emailConfiguration?.email}{" "}
                  <span className="connected-tag">CONNECTED</span>
                </p>
                <p className="mt20 heading13px text-center">
                  Removing your email account will halt all future <br />
                  email tracking and synchronization
                </p>
                <div
                  className="d-flex align-items-center mt20"
                  style={{ gap: 30 }}
                >
                  <RemoveAccount onRemove={onRemove} />
                </div>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
};

export default AccountManagement;
